export default __webpack_public_path__ + "static/media/eye.8efb292e.png";